export default __webpack_public_path__ + "static/media/litho-landing-page-img-13.1d09cb4f.jpg";